export const canRefreshProduct = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canRefreshProduct(node)
        )
    }
}

export const refreshProduct = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.runParallelAction(
                () => this.actions.refreshProduct(nodes),
                {action: '重载制品'},
            )
        )
    }
}
